"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Transforms __ref to ref
 * @param {object} props
 * @returns {object}
 * @private
 */
exports.default = function () {
  var oldProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var __ref = oldProps.__ref;

  var props = _objectWithoutProperties(oldProps, ["__ref"]);

  if (!__ref) return oldProps;

  return _extends({}, props, { ref: __ref });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/transform-props-with/lib/transform-ref.js
// module id = 1179
// module chunks = 0